// extracted by mini-css-extract-plugin
export default {"backgroundImageBot":"BackgroundImageAuthPageBotPosition_backgroundImageBot__sMii+"};